module.exports = {
  BasicText: {
    box_style: "Estilo Caja",
    classname: "Nombres de Clases",
    PluginName: "Texto Enriquecido",
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    opacity: "Opacidad",
    padding: "Padding",
    radius: "Radio",
    source: "Fuente",
    font_family: "Fuente",
    font_size: "Tamaño de fuente",
    text_color: "Color de texto",
    highlight_color: "Color de resaltado",
    bold: "Negrita",
    italic: "Cursiva",
    underline: "Subrayado",
  },
};
